import { Box } from "@mui/material";
import styled from "styled-components";

export const TravelClientsStyled = styled(Box)`
  .header {
    h2 {
      margin-bottom: 16px;
    }
  }
`;